<template>
  <section class="offer-description">
    <span v-if="displayIcon" class="offer-description__icon adn-icon adn-icon--offer-description" aria-hidden="true" />
    <p class="offer-description__text" :aria-label="i18n._(`description`)"><slot></slot></p>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { i18n } from '@b2ag/locale'

export default defineComponent({
  name: 'POfferDescription',
  props: { displayIcon: { type: Boolean, default: true } },
  setup() {
    return { i18n }
  },
})
</script>

<style lang="scss" scoped>
.offer-description {
  display: flex;
  flex-flow: row nowrap;
  border: 1px solid var(--color-border-light);
  border-radius: var(--border-radius-1);
  padding: var(--spacing-2);
}

.offer-description__icon {
  color: #eb9600;
  flex: 0 0 30px;
}

.offer-description__text {
  font-size: var(--font-size-s);
}
</style>
